<template>
    <div>
        <div class="container mb-4">
            <h1>Create an account for Film Permits</h1>
        </div>
        <div class="container" v-if="status == 'success'">
            <div class="alert alert-success">
                <h4
                    class="alert-heading"
                >One more step! We've sent you an email to verify your account.</h4>
                <p>You'll receive an email soon with a confirmation link. Once you've clicked the link, you'll be able to login.</p>
            </div>
        </div>
        <div class="container" v-if="status == 'failed'">
            <div class="alert alert-danger">
                <h4
                    class="alert-heading"
                >Oh no! Something went wrong and we couldn't create your account.</h4>
                <p>
                    Please email The Film Office in the film office at
                    <a
                        class="alert-link"
                        href="mailto:film.office@mississauga.ca"
                    >film.office@mississauga.ca</a> and they will help you complete your application or troubleshoot the problem.
                </p>

                <p>
                    If you want, you can
                    <router-link to="/create-account">try again</router-link>.
                </p>
            </div>
        </div>

        <CreateAccountForm
            @success="status = 'success'"
            @failed="status = 'failed'"
            v-if="status== ''"
        />
    </div>
</template>

<script>
import CreateAccountForm from "@/components/CreateAccountForm";

export default {
    name: "create-account",
    components: {
        CreateAccountForm
    },
    data() {
        return {
            status: ""
        };
    }
};
</script>